import Button from '@/components/ui/Button'
import appConfig from '@/configs/app.config'
import classNames from '@/utils/classNames'
import { useTranslation } from 'react-i18next'

type Props = {
    className?: string
}

/**
 * Enterprise, which is not a plan you check out.
 *
 * The Enterprise row is seeded non-public (`plan_catalogue.py`): it is a
 * sales-led yearly contract whose hours and retention live in an
 * `EntitlementOverride`, so the catalogue never lists it and there is nothing
 * to price here. This says it exists and how to ask — an email, as on the
 * website's pricing page — under the plans that can be bought.
 */
const EnterpriseContact = ({ className }: Props) => {
    const { t } = useTranslation()
    const name = t('billing.enterprise.title')
    const href = `mailto:${appConfig.salesEmail}?subject=${encodeURIComponent(
        `TrackHeros ${name}`,
    )}`

    return (
        <div
            className={classNames(
                'flex flex-wrap items-center justify-between gap-3 rounded-lg border border-dashed border-gray-300 p-4 dark:border-gray-600',
                className,
            )}
        >
            <div className="min-w-0">
                <div className="font-semibold">{name}</div>
                <p className="mt-1 text-sm text-gray-500 dark:text-gray-400">
                    {t('billing.enterprise.body')}
                </p>
            </div>
            <a href={href}>
                <Button size="sm">{t('billing.enterprise.contact')}</Button>
            </a>
        </div>
    )
}

export default EnterpriseContact
